import React from 'react';
import { GameTiles } from '../../config/GameConfig';
import './GameThumbnail.css';

interface GameThumbnailProps {
    game: GameTiles;
    handlePlayForFree: (gameId: number) => void;
    handlePlayForReal: (gameId: number) => void;
    columnTitle?: string;
}

const GameThumbnail: React.FC<GameThumbnailProps> = ({
    game,
    handlePlayForFree,
    handlePlayForReal,
    columnTitle,
}) => {
    const thumbnailContent = (
        <div className="tile">
            <img src={game.image} alt={game.name} className="game-image" />

            <div className="hover-overlay">
                <p className="game-name">{game.name}</p>

                <div className="button-container">
                    {game.isPlayable ? (
                        <>
                            <button
                                className="play-button"
                                onClick={() => handlePlayForFree(game.gameId)}
                            >
                                Play for free
                            </button>
                            <button
                                className="play-button"
                                onClick={() => handlePlayForReal(game.gameId)}
                            >
                                Play with real money
                            </button>
                        </>
                    ) : (
                        <button className="play-button" disabled>
                            Coming soon!
                        </button>
                    )
                    }
                </div>
            </div>
        </div>
    );

    if (columnTitle) {
        return (
            <div className="game-column">
                <h3 className="column-title">{columnTitle}</h3>
                <div className="column-games">
                    {thumbnailContent}
                </div>
            </div>
        );
    }

    return thumbnailContent;
};

export default GameThumbnail;
